import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const motionModelApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMotionModels: builder.query({
      query: () => "/motion_models",
      providesTags: (result, error, arg) => [{ type: 'MotionModel', id: 'LIST' }],
    }),
  }),
  overrideExisting: false
})

export const {
  useGetMotionModelsQuery
} = motionModelApiSlice 
